import { BaseIcon, BaseIconProps } from './BaseIcon';

export const AiGradient: React.FC<BaseIconProps> = (props) => (
  <BaseIcon gradientId="aiGrad" {...props}>
    <text 
      x="50%" 
      y="50%" 
      dominantBaseline="middle" 
      textAnchor="middle" 
      fill="url(#aiGrad)" 
      fontSize="14" 
      fontWeight="bold"
      fontFamily="system-ui, -apple-system, sans-serif"
    >
      AI
    </text>
  </BaseIcon>
);
